import idb from '@/store/services/idb';

// initial state
const state = {
  all: []
}

// getters
const getters = {
  getBusca: (state) => (texto) => {
    return state.all.find(busca => busca.texto == texto)
  },
  getAllBuscas: state => state.all.slice(0, 5)
}

const actions = {
  resetBuscas({ commit }) {
    commit('RESET_BUSCAS')
  },
  async loadBuscas({ commit }, texto) {
    idb.loadData('buscas', { "nome": texto });
    commit('RESET_BUSCAS');
    commit('LOAD_BUSCAS', await idb.getData('buscas'));
  },
  async getBuscas({ commit }) {
    commit('LOAD_BUSCAS', await idb.getData('buscas'));
  },
  async removeBusca({ commit }, texto) {
    commit('REMOVE_BUSCA', texto);
    var buscas = await idb.getData('buscas');
    if (buscas.length > 0) {
      var index = [];
      buscas.forEach(function(element) {
        if(texto === element.nome){
          index.push(element.id);
        }
      });
      if (index.length > 0) {
        index.forEach(async function(element) {
          await idb.deleteData('buscas', element);
        });
      }
    }
  },
}

const mutations = {
  RESET_BUSCAS: (state) => {
    state.all = [];
  },
  LOAD_BUSCAS: (state, buscas) => {
    if (buscas.length > 0) {
      buscas.forEach(function(element) {
        var index = [];
        state.all.find(function(item, i){
          if(item.nome === element.nome){
            index.push(i);
            return i;
          }
        });
        if (index.length > 0) {
          index.forEach(function(element) {
            state.all.splice(element, 1);
          });
        }
        state.all.unshift(element);
      });
    }
  },
  REMOVE_BUSCA: (state, busca) => {
    var index = [];
    state.all.find(function(item, i){
      if(item.nome === busca){
        index.push(i);
        return i;
      }
    });
    if (index.length > 0) {
      index.forEach(function(element) {
        state.all.splice(element, 1);
      });
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}